'use client';

import { c as _c } from "react/compiler-runtime";
import { Divider } from '@common/components';
import { SvgChevronleft, SvgFilter, SvgMagnifyingGlass, SvgTextfieldclose } from '@common/icon';
import { cn } from '@core/utils';
import { type FormEvent, useEffect, useRef } from 'react';
import { useCustomRouter } from '@/hooks/useCustomRouter';
import { useSubscribedState } from '@/hooks/useSubscribedState';
import { useHideOnScroll } from './_hooks/useHideOnScroll';
import { SearchCategoryDropdown } from './SearchCategoryDropdown';
interface SearchBarProps {
  keyword?: string;
  filterCount?: number;
  shouldAutoFocus?: boolean;
  /** 모바일에서 sticky + 스크롤시 자동 숨김 적용 여부. overlay 안에서는 false. */
  sticky?: boolean;
  onSearch: (keyword: string) => void;
  onFilterClick?: () => void;
  /** input의 focus/blur 신호를 부모에 전파한다. 미지정 시 동작 없음. */
  onFocusChange?: (focused: boolean) => void;
}
export function SearchBar(t0) {
  const $ = _c(49);
  const {
    keyword: t1,
    filterCount: t2,
    shouldAutoFocus: t3,
    sticky: t4,
    onSearch,
    onFilterClick,
    onFocusChange
  } = t0;
  const keyword = t1 === undefined ? "" : t1;
  const filterCount = t2 === undefined ? 0 : t2;
  const shouldAutoFocus = t3 === undefined ? false : t3;
  const sticky = t4 === undefined ? true : t4;
  const router = useCustomRouter();
  const inputRef = useRef(null);
  const [value, setValue] = useSubscribedState(keyword);
  let t5;
  if ($[0] !== sticky) {
    t5 = {
      enabled: sticky
    };
    $[0] = sticky;
    $[1] = t5;
  } else {
    t5 = $[1];
  }
  const {
    hidden
  } = useHideOnScroll(t5);
  let t6;
  let t7;
  if ($[2] !== shouldAutoFocus) {
    t6 = () => {
      if (shouldAutoFocus) {
        inputRef.current?.focus();
      }
    };
    t7 = [shouldAutoFocus];
    $[2] = shouldAutoFocus;
    $[3] = t6;
    $[4] = t7;
  } else {
    t6 = $[3];
    t7 = $[4];
  }
  useEffect(t6, t7);
  let t8;
  if ($[5] !== onSearch || $[6] !== value) {
    t8 = e => {
      e.preventDefault();
      onSearch(value.trim());
    };
    $[5] = onSearch;
    $[6] = value;
    $[7] = t8;
  } else {
    t8 = $[7];
  }
  const handleSubmit = t8;
  let t9;
  if ($[8] !== setValue) {
    t9 = () => {
      setValue("");
      inputRef.current?.focus();
    };
    $[8] = setValue;
    $[9] = t9;
  } else {
    t9 = $[9];
  }
  const handleClear = t9;
  let t10;
  if ($[10] !== hidden || $[11] !== sticky) {
    t10 = sticky && ["mobile-tablet:sticky mobile-tablet:top-0 mobile-tablet:z-10 mobile-tablet:bg-Gray-white", "mobile-tablet:transition-transform mobile-tablet:duration-200", hidden && "mobile-tablet:-translate-y-full"];
    $[10] = hidden;
    $[11] = sticky;
    $[12] = t10;
  } else {
    t10 = $[12];
  }
  let t11;
  if ($[13] !== t10) {
    t11 = cn("flex w-full flex-col items-center", t10);
    $[13] = t10;
    $[14] = t11;
  } else {
    t11 = $[14];
  }
  let t12;
  if ($[15] !== router) {
    t12 = () => router.back();
    $[15] = router;
    $[16] = t12;
  } else {
    t12 = $[16];
  }
  let t13;
  if ($[17] === Symbol.for("react.memo_cache_sentinel")) {
    t13 = <SvgChevronleft className="size-24 text-Gray-900" />;
    $[17] = t13;
  } else {
    t13 = $[17];
  }
  let t14;
  if ($[18] !== t12) {
    t14 = <button type="button" aria-label={"\uB4A4\uB85C \uAC00\uAE30"} className="hidden shrink-0 mobile-tablet:flex" onClick={t12}>{t13}</button>;
    $[18] = t12;
    $[19] = t14;
  } else {
    t14 = $[19];
  }
  let t15;
  if ($[20] === Symbol.for("react.memo_cache_sentinel")) {
    t15 = <div className="flex shrink-0 items-center mobile-tablet:min-w-0 mobile-tablet:max-w-100 mobile-tablet:shrink mobile-tablet:overflow-hidden"><SearchCategoryDropdown /><Divider variant="vertical" className="h-20 shrink-0 bg-Gray-400" /></div>;
    $[20] = t15;
  } else {
    t15 = $[20];
  }
  let t16;
  if ($[21] !== setValue) {
    t16 = e_0 => {
      setValue(e_0.target.value);
    };
    $[21] = setValue;
    $[22] = t16;
  } else {
    t16 = $[22];
  }
  let t17;
  let t18;
  if ($[23] !== onFocusChange) {
    t17 = () => onFocusChange?.(true);
    t18 = () => onFocusChange?.(false);
    $[23] = onFocusChange;
    $[24] = t17;
    $[25] = t18;
  } else {
    t17 = $[24];
    t18 = $[25];
  }
  let t19;
  if ($[26] !== t16 || $[27] !== t17 || $[28] !== t18 || $[29] !== value) {
    t19 = <input ref={inputRef} type="text" value={value} onChange={t16} onFocus={t17} onBlur={t18} placeholder={"\uAC80\uC0C9\uC5B4\uB97C \uC785\uB825\uD558\uC138\uC694"} className="flex-1 bg-transparent text-Gray-900 outline-none typo-body3 placeholder:text-Gray-550 mobile-tablet:min-w-0 mobile-tablet:tracking-[-0.28px] mobile-tablet:typo-body4" />;
    $[26] = t16;
    $[27] = t17;
    $[28] = t18;
    $[29] = value;
    $[30] = t19;
  } else {
    t19 = $[30];
  }
  let t20;
  if ($[31] !== handleClear || $[32] !== value.length) {
    t20 = value.length > 0 && <button type="button" aria-label={"\uC9C0\uC6B0\uAE30"} className="shrink-0 p-4 mobile-tablet:hidden" onClick={handleClear}><SvgTextfieldclose className="size-20" originalFill={true} /></button>;
    $[31] = handleClear;
    $[32] = value.length;
    $[33] = t20;
  } else {
    t20 = $[33];
  }
  let t21;
  if ($[34] === Symbol.for("react.memo_cache_sentinel")) {
    t21 = <button type="submit" aria-label={"\uAC80\uC0C9"} className="h-40 w-56 shrink-0 rounded-pill bg-Gray-black flex-center mobile-tablet:hidden"><SvgMagnifyingGlass className="size-20 text-Gray-white" /></button>;
    $[34] = t21;
  } else {
    t21 = $[34];
  }
  let t22;
  if ($[35] !== handleSubmit || $[36] !== t19 || $[37] !== t20) {
    t22 = <form role="search" onSubmit={handleSubmit} className="flex h-48 flex-1 items-center gap-12 rounded-pill border border-Gray-300 py-12 pl-16 pr-4 mobile-tablet:h-40 mobile-tablet:min-w-0 mobile-tablet:gap-12 mobile-tablet:text-clip mobile-tablet:rounded-xsmall mobile-tablet:border-0 mobile-tablet:bg-Gray-200 mobile-tablet:p-8">{t15}{t19}{t20}{t21}</form>;
    $[35] = handleSubmit;
    $[36] = t19;
    $[37] = t20;
    $[38] = t22;
  } else {
    t22 = $[38];
  }
  let t23;
  if ($[39] !== filterCount || $[40] !== onFilterClick) {
    t23 = onFilterClick ? <button type="button" aria-label={"\uD544\uD130"} className="hidden shrink-0 items-center gap-4 mobile-tablet:flex" onClick={onFilterClick}><SvgFilter className="size-20 text-Gray-900" />{filterCount > 0 && <span className="flex size-16 items-center justify-center rounded-pill bg-Gray-black font-700 text-Gray-white typo-caption2">{filterCount}</span>}</button> : null;
    $[39] = filterCount;
    $[40] = onFilterClick;
    $[41] = t23;
  } else {
    t23 = $[41];
  }
  let t24;
  if ($[42] !== t14 || $[43] !== t22 || $[44] !== t23) {
    t24 = <div className="flex w-full items-center mobile-tablet:gap-10 mobile-tablet:overflow-hidden mobile-tablet:px-20 mobile-tablet:py-4">{t14}{t22}{t23}</div>;
    $[42] = t14;
    $[43] = t22;
    $[44] = t23;
    $[45] = t24;
  } else {
    t24 = $[45];
  }
  let t25;
  if ($[46] !== t11 || $[47] !== t24) {
    t25 = <div className={t11}>{t24}</div>;
    $[46] = t11;
    $[47] = t24;
    $[48] = t25;
  } else {
    t25 = $[48];
  }
  return t25;
}